module.exports = __webpack_public_path__ + "static/img/shisan.d8530f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shisan.png
// module id = pfmm
// module chunks = 1